import { globalState } from '../internal/stateContainer';
import { useSelector } from './useSelector';
export var useOauthToken = function () {
    // We don't observe the full list property specified in Token.
    // We only take property that are actually used / populated in the admin shell.
    useSelector(function (state) { var _a; return (_a = state.oauthToken) === null || _a === void 0 ? void 0 : _a.access_token; });
    useSelector(function (state) { var _a; return (_a = state.oauthToken) === null || _a === void 0 ? void 0 : _a.loa; });
    useSelector(function (state) { var _a; return (_a = state.oauthToken) === null || _a === void 0 ? void 0 : _a.principal; });
    useSelector(function (state) { var _a; return (_a = state.oauthToken) === null || _a === void 0 ? void 0 : _a.scope; });
    useSelector(function (state) { var _a, _b; return (_b = (_a = state.oauthToken) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.inflightRequest; });
    return globalState.oauthToken;
};
//# sourceMappingURL=useOauthToken.js.map